// src/services/appConfig.js
import appConfigData from '../assets/data/appConfig.json';

/**
 * Service for accessing application configuration settings
 */
class AppConfigService {
  constructor() {
    this.config = appConfigData;
  }

  /**
   * Check if a specific feature is enabled
   * @param {string} featureName - Name of the feature to check
   * @returns {boolean} - True if the feature is enabled, false otherwise
   */
  isFeatureEnabled(featureName) {
    try {
      return this.config.features[featureName]?.enabled === true;
    } catch (error) {
      console.error(`Error checking feature ${featureName}:`, error);
      return false;
    }
  }

  /**
   * Get all enabled features
   * @returns {Object} - Object containing all enabled features
   */
  getEnabledFeatures() {
    const enabledFeatures = {};
    
    try {
      Object.keys(this.config.features).forEach(feature => {
        if (this.isFeatureEnabled(feature)) {
          enabledFeatures[feature] = true;
        }
      });
    } catch (error) {
      console.error('Error getting enabled features:', error);
    }
    
    return enabledFeatures;
  }

  /**
   * Get the entire configuration object
   * @returns {Object} - The entire configuration object
   */
  getConfig() {
    return this.config;
  }
}

export const appConfigService = new AppConfigService();